
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.134 11.067C22.134 4.955 17.18 0 11.067 0S0 4.955 0 11.067C0 16.591 4.047 21.17 9.338 22v-7.734h-2.81v-3.199h2.81V8.63c0-2.774 1.652-4.306 4.18-4.306 1.211 0 2.478.216 2.478.216v2.724H14.6c-1.375 0-1.804.853-1.804 1.728v2.076h3.07l-.49 3.2h-2.58V22c5.291-.83 9.338-5.409 9.338-10.933","fill":"#BF9C5F","fill-rule":"evenodd"}})])
          )
        }
      }
    